module.exports = __webpack_public_path__ + "img/card@2x.c5f4b9d2.png";